<template>

<div>
    <div class="reklamark">
      <br><br>
        <img id="tips1" src="../../assets/tips1.jpg"  alt="tips1" >
    </div>
</div>



</template>

<script>
export default {
  name: 'Vy1',
  props: {
    msg: String
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.reklamark {
    width: calc(100vw - 463px);
    height: calc(100vh - 250px);
    margin: auto;
    background-color: white;
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    background: rgba(255, 255, 255, 0.8);

    -webkit-animation: mjukframkomst 1s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjukframkomst 1s;
    /*animation-delay: 2s;*/
    position: relative;
}

@media (max-width: 1024px) {
    .reklamark {
        width: 100%;
    }
}
.centrerat {
    margin: auto;
}

.budskap0{
    padding-top: 1em;
    font-size: 2em;


}


.budskap1{
    -webkit-animation: mjuk1 2s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjuk1 2s;
    /*text-align: center;*/


    font-size: 2em;
    font-family: serif;
    color:black;
    top: calc(30% + 30px);
    position: absolute;
    left:calc(50% - 90px);
}


.budskap2{
    -webkit-animation: mjuk2 3s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjuk2 3s;
    left:40%;


    font-size: 2em;
    font-family: serif;
    color: black;
    top: calc(50% + 30px);
    position: absolute;
    left:calc(50% - 90px);

}

.budskap3{
    -webkit-animation: mjuk3 8s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjuk3 8s;
    text-align: left;
    padding-left: 2em;

    font-size: 2em;
    font-family: serif;
    color: #2c2d01;
    top: calc(60% + 30px);
    position: absolute;
}


/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukframkomst {
  0% {
      opacity: 0;
  }
  75% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@-webkit-keyframes mjuk1 {
  0% {
      opacity: 0;
  }
  80% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@-webkit-keyframes mjuk2 {
  0% {
      opacity: 0;
  }
  85% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@-webkit-keyframes mjuk3 {
  0% {
      opacity: 0;
  }
  90% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

.knappjox {
    padding:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: black;
}

.pad0 {
    padding-left:2px;
    padding-right:2px;
}

.pad1 {
    padding-left:13px;
    padding-right:13px;
}
.pad2 {
    padding-left:10px;
    padding-right:10px;
}

#tips1 {

  max-height:80%;
  max-width:80%;
}
</style>
